import React from 'react';
import Navbar from './components/NavBars/Navbar';
import './App.css';
import { 
  BrowserRouter, 
  Routes,
  Route,
} from 'react-router-dom';
import Products from './components/pages/Products';
import Contactus from './components/pages/ContactUs';
import Edit from './components/pages/Edit';
import BookingCalendar from './components/pages/BookingCalendar';
import AddTalent from './components/pages/AddTalent';
import TalentList from './components/pages/TalentList';
import CompanyList from './components/pages/CompanyList';
import AddCompany from './components/pages/AddCompany';
import LanoCreateATask from './components/pages/LanoCreateATask';
import AppNavbar from './components/AppNavbar'
import ProtectedRoute from './helpers/ProtectedRoute'; 
import NoPrivilages from './components/pages/NoPrivilages';
import NewBookingCreationPage from './components/pages/ClientService/NewBookingCreationPage';
import ProposeTalentsBookingDetail from './components/SetCastUser/ProposeTalentsBookingDetail';
import NewBookingsPage from './components/SetCastUser/NewBookingsPage';
import MyBookingsPage from'./components/pages/Talent/MyBookingsPage'
import LoginForm from './LoginForm';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import UserDataForm from './components/pages/UserDataForm';
import NewUserRegistration from './components/pages/NewUserRegistration';
import SetVacationPage from './components/pages/Talent/SetVacationPage';
import MyInvitations from './components/pages/Talent/MyInvitations';
import TalentInvitations from './components/pages/Talent/TalentInvitations';
import ProposedBookingsPage from './components/pages/ClientService/ProposedBookingsPage';
import EditBooking from './components/SetCastUser/EditBooking';
import AllBookings from './components/SetCastUser/AllBookings';
import Profile from './components/pages/Profile';
import ExcelUploadButton from './helpers/ExcelUploadButton';
import UploadHistory from './components/pages/UploadHistory';
import AllBookingsPage from './components/pages/AllBookingsPage';
import ConfirmedBooking from './components/SetCastUser/ConfirmedBooking';
import TalentListPlaniing from './components/pages/ClientService/TalentListPlaniing';
import AllFutureBookingGroups from './components/pages/AllFutureBookingGroups';
import BookingDetailsPage from './components/SetCastUser/BookingDetailsPage';
import TalentOrdersList from './components/pages/Talent/TalentOrdersList';
import TalentsOnHold from './components/SetCastUser/TalentsOnHold';
import CreateDummyOrders from './components/SetCastUser/CreateDummyOrder';
import RequestedBookings from './components/SetCastUser/RequestedBookings';
import TalentListCalendar from './components/pages/talentListCalendar';
import { CalendarProvider } from './helpers/CalendarContext';
import TalentUserCreationForm from './components/TalentUserCreationForm';
import DeletedOrdersPage from './components/SetCastUser/DeletedOrdersPage';
import LanoIds from './components/pages/LanoIds';
import TalentOverview from './components/pages/ClientService/TalentOverview';
import MyCalendar from './components/pages/Talent/MyCalendar';
import HomePage from './components/pages/Talent/HomePage';
import NewAllBookings from './components/SetCastUser/NewAllBookings';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import CalendarPageWithData from './components/pages/CalendarPage';
import LoginTest from './components/LoginTest';
import TalentListApi from './components/pages/Talent/TalentListApi';
import TalentCalendarPage from './components/pages/Talent/TalentCalendarPage';
import CompanyGroupManagement from './components/pages/Admin/CompanyGroupManagement';
import TalentRelationshipView from './components/pages/TalentRelationshipView';
import OldTalentList from './components/pages/ClientService/OldTalentList';
import Footer from './components/Footer';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

function AppRoutes() {
  const { currentUser, userRole } = useAuth();

  // Special route for login test page
  if (window.location.pathname === '/login-test') {
    return <LoginTest />;
  }

  // If user is not authenticated, show login or password reset pages
  if (!currentUser) {
    return (
      <Routes>
        <Route path="/" element={<LoginForm />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/login-test" element={<LoginTest />} />
        <Route path="*" element={<LoginForm />} />
      </Routes>
    );
  }

  // User is authenticated, show the app with proper navigation
  return (
    <>
      <AppNavbar />
      <Routes>
        <Route path="/login-test" element={<LoginTest />} />
        <Route path="/np/*" element={<ProtectedRoute allowedRoles={[null]} />}>
          <Route index element={<NoPrivilages />} />
        </Route>

        <Route path="/admin/*" element={<ProtectedRoute allowedRoles={['superadmin', 'setCastEditor']} />}>
          <Route path='propose' element={<ProposeTalentsBookingDetail />} />
          <Route path='company-group' element={<CompanyGroupManagement />} />
          <Route path='newallbookings' element={<NewAllBookings />} />
          <Route path='upload' element={<ExcelUploadButton />} />
          <Route index element={<NewBookingsPage />} />
          <Route path='neworders' element={<NewBookingsPage />} />
          <Route path="addtalent" element={<AddTalent />} />
          <Route path="add-company" element={<AddCompany />} />
          <Route path='company-list' element={<CompanyList />} />
          <Route path="lanotaskcreate" element={<LanoCreateATask />} />
          <Route path='products' element={<Products />} />
          <Route path='lanoids' element={<LanoIds />} />
          <Route path='edit' element={<EditBooking />} />
          <Route path='user-data' element={<UserDataForm />} />
          <Route path='new-user-registration' element={<NewUserRegistration />} />
          <Route path='talent-relationships' element={<TalentRelationshipView />} />
          <Route path='profile' element={<Profile />} />
      
          <Route path='allbooking' element={<NewAllBookings />} />
          <Route path='talent-list' element={<TalentList />} />
          <Route path='talent-list-api' element={<TalentListApi />} />
          <Route path='history' element={<UploadHistory />} />
          <Route path='confirmed' element={<ConfirmedBooking />} />
          <Route path='allgroups' element={<AllFutureBookingGroups />} />
          <Route path='detail' element={<BookingDetailsPage />} />
          <Route path='new'element={<NewBookingCreationPage />} />
          <Route path='talents-hold'element={<TalentsOnHold />} />
          <Route path='create-dummy'element={<CreateDummyOrders />} />
          <Route path='requested'element={<RequestedBookings />} />
          <Route path='tlistcal'element={<TalentListCalendar />} />
          <Route path='bulk-create'element={<TalentUserCreationForm />} />
          <Route path='deleted'element={<DeletedOrdersPage />} />
          <Route path='calendar'element={<CalendarPageWithData />} />
        </Route>

        <Route path="/user/*" element={<ProtectedRoute allowedRoles={['editor', 'superadmin', 'setCastEditor']} />}>
          <Route path="addtalent" element={<AddTalent />} />
          <Route path="lanotaskcreate" element={<LanoCreateATask />} />
          <Route path='contact-us' element={<Contactus />} />
          <Route index element={<BookingCalendar />} />
          <Route path="add-company" element={<AddCompany />} />
          <Route path='company-list' element={<CompanyList />} />
          <Route path='talent-list' element={<TalentList />} />
          <Route path='profile' element={<Profile />} />
          <Route path='calendar'element={<CalendarPageWithData />} />
        </Route>

        <Route path="/talent/*" element={<ProtectedRoute allowedRoles={['talent', 'superadmin']} />}>
          <Route index element={<HomePage />} />
          <Route path='home' element={<HomePage />} />
          <Route path='my-bookings-page' element={<MyBookingsPage />} />
          <Route path='vacation' element={<SetVacationPage />} />
          <Route path='my-invitations' element={<MyInvitations />} />
          <Route path='invitations' element={<TalentInvitations />} />
          <Route path='profile' element={<Profile />} />
          <Route path='orders' element={<TalentOrdersList />} />
          <Route path='calendar'element={<CalendarPageWithData />} />
          <Route path='my-calendar'element={<TalentCalendarPage />} />
        </Route>

        <Route path="/cs/*" element={<ProtectedRoute allowedRoles={['clientService', 'superadmin', 'planning']} />}>
          <Route index element={<AllBookingsPage />} />
          <Route path='company-group' element={<CompanyGroupManagement />} />
          <Route path='old-talent-list' element={<OldTalentList />} />
          <Route path='new'element={<NewBookingCreationPage />} />
          <Route path='talent-list' element={<TalentList />} />
          <Route path='allbooking' element={<AllBookingsPage />} />
          <Route path="add-company" element={<AddCompany />} />
          <Route path='company-list' element={<CompanyList />} />
          <Route path='proposed' element={<ProposedBookingsPage />} />
          <Route path='profile' element={<Profile />} />
          <Route path='rate-talent' element={<TalentListPlaniing />} />
          <Route path='allgroups' element={<AllFutureBookingGroups />} />
          <Route path='upload' element={<ExcelUploadButton />} />
          <Route path='tlistcal'element={<TalentListCalendar />} />
          <Route path='talentoverview'element={<TalentOverview />} />
          <Route path='talent-relationships' element={<TalentRelationshipView />} />
          <Route path='edit' element={<EditBooking />} />
          <Route path='calendar'element={<CalendarPageWithData />} />
        </Route>
      </Routes>
      <Footer/>
    </>
  );
}

export default App;
